import type { AxiosRequestConfig } from 'axios';
import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams, SortDirection } from '@/types/apiQuery';
import type { HistoryItem, Order } from '@/types/order';
import type { EndpointResponse } from '@/types/endpoints';
import { utils } from '@/utils';

type RequestParams = Pick<ApiQueryParams, 'limit' | 'page'> & {
  orderId: Order['id'];
  sortDirection?: SortDirection;
};
export type OrderHistoryRequestOptions = Pick<AxiosRequestConfig, 'signal' | 'operationRequirement'>;

type Response = HistoryItem[];

export const getOrderHistory = async (
  scope: RequestScope,
  { orderId, limit = 50, page = 1, sortDirection = 'desc' }: RequestParams,
  options: OrderHistoryRequestOptions = {}
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>(`/order/${orderId}/order_history`, {
      ...options,
      params: {
        sort: sortDirection === 'asc' ? 'created_at:1' : 'created_at:-1',
        limit,
        page,
      },
    });

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
